import {
    AdminApiAdminsService,
    AdminApiAppointmentsService,
    AdminApiAuthService,
    AdminApiPracticesService,
    AdminApiUsersService,
    createAPI,
    createAxiosInstance,
} from '@mybonum/api';
import { generatePath } from 'react-router';

import { EAdminRoutes } from '@/services/router/enums.ts';

const redirectUrl = `${window.location.origin}${generatePath(EAdminRoutes.Login)}`;

const apiInstance = createAxiosInstance(redirectUrl, import.meta.env.VITE_API_URL);

export const API = createAPI(
    {
        ADMINS: AdminApiAdminsService,
        USERS: AdminApiUsersService,
        AUTH: AdminApiAuthService,
        PRACTICES: AdminApiPracticesService,
        APPOINTMENTS: AdminApiAppointmentsService,
    },
    apiInstance
);
